var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcoTooltipLogin = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 37,
  height: 37,
  viewBox: "0 0 37 37"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#1274C4",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M19 19c-2.217 0-4.019-1.794-4.019-4s1.802-4 4.019-4 4.019 1.794 4.019 4-1.802 4-4.019 4m3.776.673a5.978 5.978 0 0 0 2.182-5.603c-.397-2.623-2.589-4.722-5.236-5.028-3.652-.423-6.75 2.407-6.75 5.958 0 1.89.88 3.574 2.252 4.673-3.372 1.261-5.834 4.222-6.22 8.218A1.012 1.012 0 0 0 10.009 29a.99.99 0 0 0 .993-.891C11.404 23.646 14.837 21 19 21s7.596 2.646 7.999 7.109a.99.99 0 0 0 .993.891c.596 0 1.06-.518 1.003-1.109-.385-3.996-2.847-6.957-6.22-8.218"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "nonzero",
  d: "M19 34c8.284 0 15-6.716 15-15 0-8.284-6.716-15-15-15-8.284 0-15 6.716-15 15 0 8.284 6.716 15 15 15Zm0 2C9.611 36 2 28.389 2 19S9.611 2 19 2s17 7.611 17 17-7.611 17-17 17Z"
}))));
export { SvgIcoTooltipLogin as ReactComponent };
export default __webpack_public_path__ + "assets/media/ico-tooltip-login.aa2f7490c4de84bf71c551525f96e9a5.svg";